import { postAiRequest } from '../../common/ApiClient';
import { GetArticleRecommendationsResponse } from '../../ai-recommendation/types/GetArticleRecommendationsResponse';

export const getMostReadRecommendations = async ({
  postNumber,
  excludeIds,
  period,
  userToken,
  userId,
  country,
  isLife,
}: {
  postNumber: number;
  excludeIds: string[];
  period: string;
  userToken: string;
  userId?: string;
  country: 'HU' | 'SK' | 'CZ';
  isLife: boolean;
}): Promise<GetArticleRecommendationsResponse[]> => {
  const { data } = await postAiRequest<GetArticleRecommendationsResponse[]>(`recommendation/most-viewed-posts`, {
    postNumber,
    excludeIds,
    period,
    userToken,
    userId,
    country,
    isLife,
  });

  return data;
};
